import { AxiosError } from 'axios'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { urlList } from '../constants/constants'
import { routePaths } from '../pages/RootPage'
import { apiService } from '../services'
import authService from '../services/authService'
import { RootState } from '../store'
import {
  clearUserState,
  setCurrentUser,
  User,
} from '../store/reducers/userReducer'

interface UseCurrentUserProps {
  preventFetch?: boolean
}

const useCurrentUser = ({ preventFetch = false }: UseCurrentUserProps) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const currentUser = useSelector((state: RootState) => state.user.currentUser)

  useEffect(() => {
    if (!preventFetch) {
      const fetchCurrentUser = async () => {
        setLoading(true)
        try {
          const response: User = await apiService.fetchItems(
            urlList.CURRENT_USER
          )
          dispatch(setCurrentUser(response))
        } catch (error) {
          console.error('axios fetch error', error)
          apiService.handleError401(error as AxiosError, navigate)
        } finally {
          setLoading(false)
        }
      }

      fetchCurrentUser()
    }
  }, [preventFetch, dispatch, navigate])

  const handleLogout = useCallback(async () => {
    setLoading(true)
    try {
      await authService.logout()
      navigate(routePaths.LOGIN)
    } catch (error) {
      console.error('Logout error', error)
      navigate(routePaths.LOGIN)
    } finally {
      setLoading(false)
      dispatch(clearUserState())
    }
  }, [navigate, dispatch])

  return {
    currentUser,
    loading,
    handleLogout,
  }
}

export default useCurrentUser
